import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Records";
import getToken from "app/api/getToken";

export const DELETE_RECORD_REQUEST = "DELETE_RECORD_REQUEST";
export const DELETE_RECORD_SUCCESS = "DELETE_RECORD_SUCCESS";
export const DELETE_RECORD_FAIL = "DELETE_RECORD_FAIL";

export const delRecord = (id: number) => (dispatch: any): any => {
  dispatch({ type: DELETE_RECORD_REQUEST });

  const token = getToken();

  return api
    .delRecord(token, id)
    .then((response: AxiosResponse) => {
      dispatch({ type: DELETE_RECORD_SUCCESS });
    })
    .catch(err => {
      dispatch({
        type: DELETE_RECORD_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
